import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";

const DialogSignConfirmation = ({ confirmInfo, handleCloseDialog }) => {
  const [accepted, setAccepted] = useState(false);

  const handleClose = () => {
    setAccepted(false);
    handleCloseDialog(false);
  };

  const handleConfirm = () => {
    setAccepted(false);
    handleCloseDialog(true, confirmInfo.data);
  };

  return (
    <Dialog
      open={confirmInfo.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-sign-title"
      aria-describedby="alert-dialog-sign-description"
    >
      <DialogTitle id="alert-dialog-sign-title">{confirmInfo.title}</DialogTitle>
      <DialogContent>
        <Box sx={{ bgcolor: "#f0f0f0", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Registrar Firma Electrónica
          </Typography>
          <Typography variant="body2">
            Mediante la activación de este botón, usted manifiesta que está totalmente
            de acuerdo con el contenido del documento a generar. Por lo tanto autoriza continuar
            el trámite y permitir el registro electrónico de su firma sobre el documento.
          </Typography>
        </Box>
        {confirmInfo.error &&
          <Typography variant="body2" sx={{ color: "#d32f2f", mb: 1 }}>
            {confirmInfo.error}
          </Typography>
        }
        <FormControlLabel
          control={
            <Switch
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              disabled={!!confirmInfo.error}
            />
          }
          label="Acepto firmar electrónicamente este documento"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          {confirmInfo.cancel || "Cancelar"}
        </Button>
        <Button onClick={handleConfirm} color="primary" disabled={!accepted}>
          {confirmInfo.confirm || "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogSignConfirmation;
